export default __webpack_public_path__ + "static/media/instagram.de28769a.svg";